import { useEffect, useState, useCallback } from 'react';
import useAvailablePlans from 'hooks/useAvailablePlans';
import { Text, Stack, Select, Link, Button } from '@chakra-ui/react';
// ...existing code...
import useServerApi from '../../../hooks/useServerApi';
import Plans from './Plans';
import AddPaymentModal from './AddPaymentModal';
import CreateAgentFormWrapper from '../components/CreateAgentFormWrapper';
// ...existing code...
import { PATHS } from 'router/routes';
import { useNavigate } from 'react-router-dom';
import { useUserData } from 'context/UserDataProvider';

const UpgradePlan = () => {
    const navigate = useNavigate();
    const [{ get, post }] = useServerApi();
    const { fetchUserData } = useUserData();
    const [priceId, setPriceId] = useState('');
    const [errors, setErrors] = useState('');
    const [paymentSources, setPaymentSources] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedSource, setSelectedSource] = useState('');
    const [isAddSourceOpen, setIsAddSourceOpen] = useState(false);
    const { activeProducts, subscriptions, loading: plansLoading } = useAvailablePlans();
    // const stripePromise = loadStripe(stripeKey);

    // ...existing code...

    const fetchPaymentSources = useCallback(async () => {
        const [paymentSuccess, paymentResponse] = await get('/rest_endpoints/stripe/crud/payment_sources');
        if (paymentSuccess) {
            const paymentSources = paymentResponse.payment_sources ?? [];
            setPaymentSources(paymentSources);
            setSelectedSource(paymentSources.length > 0 && paymentSources[0] ? paymentSources[0].payment_id : '');
        }
    }, [get]);

    const handleSave = async () => {
        setLoading(true);
        const [success, response] = await post('/rest_endpoints/stripe/crud/update_subscription', { priceId, trialEnd: false });
        setLoading(false);

        if (success) {
            // Fetch user data before navigating
            if (fetchUserData) {
                await fetchUserData();
            }
            navigate(PATHS.MY_AGENT);
        } else {
            setErrors(response?.message || "Failed to update subscription.");
        }
    };

    useEffect(() => {
        setErrors('');
        if (subscriptions.length === 0) {
            setErrors('There are no subscriptions.');
        }
        if (activeProducts.length > 0) {
            const subscriptionProduct = subscriptions.length > 0 ? subscriptions[0].product : "";
            activeProducts.forEach(product => {
                if (product.id === subscriptionProduct) {
                    setPriceId(product.priceId);
                }
            });
        }
        fetchPaymentSources();
    }, [activeProducts, subscriptions, plansLoading, fetchPaymentSources]);


    if (loading || plansLoading) {
        return (
            <CreateAgentFormWrapper
                title='Upgrade Your Plan'
                description='Select a new plan to upgrade your agent subscription.'
            >
                <Text>Loading...</Text>
            </CreateAgentFormWrapper>
        );

    }
    if (subscriptions.length === 0 && !loading && !plansLoading) {
        return (
            <CreateAgentFormWrapper
                title='Upgrade Your Plan'
                description='Select a new plan to upgrade your agent subscription.'
            >
                <Text color="red.500">No Subscription to show</Text>
            </CreateAgentFormWrapper>
        );
    }

    return (
        <CreateAgentFormWrapper
            title='Upgrade Your Plan'
            description='Select a new plan to upgrade your agent subscription.'
        >
            {errors && <Text color="red.500">{errors}</Text>}
            <div className='w-full max-w-none grid gap-2 md:grid-cols-2 lg:grid-cols-3'>
                {activeProducts.map((product) => (
                    <Plans
                        key={product.id}
                        product={product}
                        priceId={priceId}
                        setPriceId={setPriceId}
                    />
                ))}
            </div>
            <Text fontWeight='bold'>Cancel anytime • No contract</Text>
            <Select placeholder="Select a payment source" value={selectedSource} onChange={(e) => setSelectedSource(e.target.value)} mt={4}>
                {paymentSources.slice(0, 3).map(source => (
                    <option key={source.payment_id} value={source.payment_id}>**** **** **** {source.last4}</option>
                ))}
            </Select>
            <Link mt={2} color="blue.500" onClick={() => setIsAddSourceOpen(true)}>Add New Card</Link>

            <AddPaymentModal
                isOpen={isAddSourceOpen}
                onClose={() => setIsAddSourceOpen(false)}
                onSuccess={() => {
                    fetchPaymentSources();
                    setIsAddSourceOpen(false);
                }}
                setErrors={setErrors}
            />

            {/* Action Buttons */}
            <Stack direction='row' spacing={4} mt={6} justify='flex-end'>
                <Button
                    variant='outline'
                    fontSize='sm'
                    onClick={() => navigate(PATHS.MY_AGENT)}
                >
                    Back
                </Button>
                {selectedSource && priceId && (
                    <Button
                        colorScheme='green'
                        variant='solid'
                        fontSize='sm'
                        onClick={() => {
                            handleSave();
                        }}
                    >
                        Save
                    </Button>
                )}
            </Stack>
        </CreateAgentFormWrapper>
    );
};

export default UpgradePlan;
